<div class="success-page">
  <umkt-toast></umkt-toast>

  <header class="success-header">
    <div class="logo-container">
      <img
        src="https://mondrian.claro.com.br/brands/horizontal/default/claro-empresas.svg"
        alt="Claro empresas"
        class="claro-logo"
      />
    </div>
  </header>

  <main class="success-main">
    <div class="success-content">
      <div class="illustration-container">
        <img
          src="assets/images/success_register.png"
          [alt]="'pages.successRegister.imageAlt' | i18n"
          class="success-illustration"
        />
      </div>

      <h1 class="success-title">
        {{ (isTokenFlow ? 'pages.successRegister.titleOrder' : 'pages.successRegister.title') | i18n }}
      </h1>

      <div class="success-message">
        <p *ngIf="!isTokenFlow" 
           [innerHTML]="'pages.successRegister.message' | i18n: { email: email || 'nome@company.com.br' }">
        </p>
        
        <p *ngIf="isTokenFlow"
           [innerHTML]="'pages.successRegister.messageOrder' | i18n: { email: email || 'nome@company.com.br' }">
        </p>
      </div>

      <button *ngIf="!isTokenFlow" class="resend-link" (click)="resendEmail()" [disabled]="loading">
        {{ (loading ? 'pages.successRegister.resendingButton' : 'pages.successRegister.resendButton') | i18n }}
      </button>
    </div>
  </main>

  <footer class="success-footer">
    <div class="footer-content">
      <div class="copyright">
        ©{{currentYear}} {{ 'pages.successRegister.footer.rights' | i18n }}
      </div>
      <div class="privacy-links">
        <a href="#" class="privacy-link">{{ 'pages.successRegister.footer.privacyPolicy' | i18n }}</a>
        <a href="#" class="privacy-link">{{ 'pages.successRegister.footer.privacyPortal' | i18n }}</a>
        <div class="claro-icon"></div>
      </div>
    </div>
  </footer>
</div>